import { createSlice } from "@reduxjs/toolkit"
import { difference, isNull } from "lodash"
import { subscribe } from "lib/live_events"

import recentMessages from "../../api/unreadMessages"

const initialState = {
  unread_comments: [],
  initialized: false
}

const slice = createSlice({
  name: "unread",
  initialState,
  reducers: {
    setComments: (state, { payload: comments }) => {
      state.unread_comments = comments
      state.initialized = true
    },

    addComment:(state, { payload: comment_id }) => {
      state.unread_comments.push(comment_id)
    },

    removeComments: (state, { payload: comment_ids}) => {
      state.unread_comments = difference(state.unread_comments, comment_ids)
    },

    incrementTotal: (state, { payload: increment = 1 }) => {
      if (isNull(state.total)) return
      state.total += increment
    },

    decrementTotal: (state, { payload: decrement}) => {
      state.total -= decrement
    }
  }
})

export const getUnreadCount = (state) => state.unread.unread_comments.length
export const isUnreadInitialized = (state) => state.unread.initialized

// 🔹 Listener middleware (same file)
export function registerListeners(listenerMiddleware, initAction) {
  listenerMiddleware.startListening({
    actionCreator: initAction,
    effect: async (action, { dispatch }) => {
      // Subscribe to live events and bump total
      subscribe("messaging.new_comment", (comment) => {
        dispatch(slice.actions.addComment(comment.id))
      })

      // Subscribe to live events and bump total
      subscribe("messaging.read_thread", ({ read_messages }) => {
        dispatch(slice.actions.removeComments(read_messages))
      })
    }
  })
  
  listenerMiddleware.startListening({
    actionCreator: initAction,
    effect: async (action, { dispatch }) => {
      recentMessages({per_page: 9999, with_data: false}).then(({data}) => {
        dispatch(slice.actions.setComments(data.list))
      }) 
    }
  })
}

export default slice.reducer
